export const chopinEnvironment = () => {
  if (globalThis.window) {
    const envMetaElement = window.document
      ? window.document.querySelector('meta[name="env"]')
      : null;

    return envMetaElement?.getAttribute("content") || "development";
  }
  // SSR
  return "development";
};
